import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router); // Use Angular's dependency injection to get the Router

  const isLBBasicUser = (): boolean => {
    const permissions = localStorage.getItem('permissions');
    return !!permissions && (permissions.includes('4') || permissions.includes('5') || permissions.includes('6') || permissions.includes('7'));
  };
  //Always returns true, as everyone should be able to access lb atm. Not deleting to keep the code just in case
  if (isLBBasicUser()) {
    return true; // Allow access
  } else {
    //router.navigate(['/landing']); // Redirect to landing page
    return true; // Deny access
  }
};
